export default "__VITE_ASSET__CgKd0_3A__"